import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend/index';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { DBDef_Score } from '@app/hcs-shared';
import { ModuleFE_Variable } from '../variable/index.js';
export const dispatch_onScoresUpdated = new ThunderDispatcherV3('__onScoresUpdated');
export class ModuleFE_Score_Class extends ModuleFE_BaseApi {
    __searchFilterMapper = (item) => [ModuleFE_Variable.cache.unique(item.variableId).name];
    __searchGroups = (items) => ([{
            group: this.dbDef.entityName,
            results: items.map(i => {
                const variable = ModuleFE_Variable.cache.unique(i.variableId);
                return { _id: i._id, uiLabel: variable.name };
            })
        }]);
    constructor() {
        super(DBDef_Score, dispatch_onScoresUpdated);
    }
}
export const ModuleFE_Score = new ModuleFE_Score_Class();
//# sourceMappingURL=ModuleFE_Score.js.map